import { FruitType } from "../../context";

export const folderText = [
	`С кого начнёте: с деловой колбасы, сэндвич-ролла «Цезарь» или пирожного корзиночки? Проверяйте кандидатов, а мы подарим вам промокод на скидку, чтобы вы лично убедились в качестве наших продуктов`,
	`Рады видеть вас снова. Устройте на полку оставшихся кандидатов и получите промокод. Кого проверим в этот раз?`,
	`Ещё раз привет! Осталось проверить последнего кандидата и забрать промокод. Приступим?`,
	`И снова здравствуйте! Вы проверили всех кандидатов и забрали промокод — теперь можете поиграть просто в удовольствие`,
];

export const boldWords = [
	"подарим вам промокод на скидку",
	"второй промокод",
];

interface Character {
	name: string;
	type: FruitType;
}

export const characters: Character[] = [
	{ name: "ПирОжНое", type: "cake" },
	{ name: "Колбаса", type: "sausage" },
	{ name: "рОлЛ", type: "roll" },
];

export const onboardSteps = [
	`Проводим минимум 40 000 лабораторных проверок продуктов в месяц`,
	`Оцениваем чистоту состава не только по российским, но и по европейским нормам. Мы используем лишь единицы добавок из 300 разрешённых в РФ`,
	`Не пропускаем даже популярные у других добавки: бензоат натрия (E211), нитрит натрия (E250), антибиотики, синтетические красители и подсластитель аспартам`,
	`Разрабатываем вместе с учёными новые методы поиска вредных добавок`,
	`Проверяем не только продукты, но и поставщиков — проводим не меньше 170 аудитов в месяц`,
	`Быстро реагируем на отзывы покупателей: доработаем продукт или уберём его с полок за пару часов`
];

export const infoSteps = [
	`Разрешено в РФ – не значит разрешено у нас: используем единицы добавок из 300 разрешённых`,
	`Не пропускаем даже популярные добавки: антибиотики, синтетические красители, аспартам, бензоат и нитрит натрия`,
	`Берём в команду учёных и придумываем, как по-новому вычислить вредные добавки`
]
